import React, { Component } from 'react';
import { connect } from 'formik';
import Input from '../../../../components/input/text/input-formik';
import { ILTIActivityAddProps, IOuterProps, IFormikProps } from '../../../../models/components/add-activity-lti-content';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import { Quil } from '../../../../components/input/quil/main';
import { SelectAsync } from '../../../../components/input/select/main';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Common } from '../../../../core/common';
import Tooltip from '../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;

export class LTIActivityContent extends Component<IFormikProps> {
    public state = {
        isModelOpen: false
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public timingControl = (type: number) => {
        this.props.formik.values.dateCriteria === type ?
            this.props.formik.setFieldValue('dateCriteria', -1) :
            this.props.formik.setFieldValue('dateCriteria', type);
    }

    handleDatePrerequisiteActivityId = (selectedValue: any) => {
        this.props.formik.setFieldValue('datePrerequisiteActivityId', selectedValue.value);
        this.props.formik.values.datePrerequisiteActivityId = selectedValue.value;
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_contentTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_contentTab' ? 'block' : 'none' }}
                id="forum-setting"
                role="tabpanel"
                aria-labelledby="forum-setting-tab"
            >
                <SelectAsync
                    isMulti={false}
                    isSearchable={true}
                    isClearable={true}
                    requestType={'post'}
                    parameter={{ searchedText: '' }}
                    placeHolder={T.t('r_activity_add_lti_name')}
                    url={'api/lti/names'}
                    closeMenuOnScroll={true}
                    closeMenuOnSelect={true}
                    setSelectValue={this.props.formik ? this.props.formik.values.ltiId : ''}
                    name={'ltiId'}
                    setFieldOnlyValue={true}
                    value={this.props.formik.values.ltiId}
                    onChange={this.props.formik.handleChange}
                    setFieldValue={this.props.formik.setFieldValue}
                    errors={this.props.formik.errors.ltiId}
                    touched={this.props.formik.touched.ltiId}
                    isTouched={this.props.formik.setFieldTouched}
                    colourStyles={{
                        menu: () => ({ zIndex: 999999 })
                    }}
                />
                &nbsp;
                <h5 className="mb-0">{T.t('r_activity_search_placeholder')}<span className="ml-1" style={{ color: '#dc5050' }}>*</span></h5>
                <Input type={'text'} name={'name'} placeHolder={T.t('r_activity_search_placeholder')} formik={this.props.formik} />
                <p className="half-color">{T.t('r_activity_list_shown_text')}</p>
                <h5 className="mt-4 mb-2">{T.t('r_description')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_write_description_for_activity')}
                    /* tslint:disable */
                    onChange={(e: any) => this.props.formik.setFieldValue('description', e)}
                    value={this.props.formik.values.description || ''}
                    theme={'snow'}
                />
                {!this.props.isProjectSubActivity && (
                    <>
                        <div className='d-flex align-items-center'>
                            <h5 className="mt-4 mt-0">{T.t('r_timing')}</h5>
                            <Tooltip data={T.t('r_timing_info')} position='top'>
                                <img src={_common.GetDefaultIcons('info')} style={{ width: '1.25em', marginInlineStart: "20px" }} alt="" />
                            </Tooltip>
                        </div>
                        <div className="row">
                            {this.props.isWeekly && (
                                <div className="col-md-4">
                                    <div className="radio-tabs tick-radio position-relative">
                                        <input
                                            type="checkbox"
                                            name={'dateCriteria'}
                                            onChange={this.timingControl.bind(this, 0)}
                                            value={0}
                                            id="time-zero"
                                            className="form-radio"
                                            checked={this.props.formik.values.dateCriteria === 0 ? true : false}
                                            style={{ borderRadius: 100 }}
                                        />
                                        <label htmlFor="time-zero" style={{ marginInlineStart: "6px" }}>
                                            {T.t('r_show_by').replace('{0}', this.props.termType)}
                                        </label>
                                    </div>
                                </div>
                            )}
                            <div className="col-md-4">
                                <div className="radio-tabs tick-radio position-relative">
                                    <input
                                        type="checkbox"
                                        name={'dateCriteria'}
                                        onChange={this.timingControl.bind(this, 1)}
                                        value={1}
                                        id="time-one"
                                        className="form-radio"
                                        checked={this.props.formik.values.dateCriteria === 1 ? true : false}
                                        style={{ borderRadius: 100 }}
                                    />
                                    <label htmlFor="time-one" style={{ marginInlineStart: "6px" }}>{T.t('r_publish_by_date')}</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                    <input
                                        type="checkbox"
                                        name={'dateCriteria'}
                                        onChange={this.timingControl.bind(this, 2)}
                                        value={2}
                                        id="time-two"
                                        className="form-radio"
                                        checked={this.props.formik.values.dateCriteria === 2 ? true : false}
                                        style={{ borderRadius: 100 }}
                                    />
                                    <label htmlFor="time-two" style={{ marginInlineStart: "6px" }}>{T.t('r_show_by_another_activity')}</label>
                                </div>
                            </div>
                        </div>
                        <div className="row" id="forum_publish_date" style={{ marginTop: 0 }}>
                            <div className="col-md-6">
                                <div
                                    style={{
                                        display: this.props.formik.values.dateCriteria === 1 ? 'block' : 'none'
                                    }}
                                >
                                    <h5 className="mt-4 mt-0">{T.t('r_show_after_date')}</h5>
                                    <div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                                        <div className="row" id="assignment_by_begin_date" style={{ marginTop: 0 }}>
                                            <div className="col-md-6">
                                                <div className="form-input form-group date-picker mb-md-0">
                                                    <DatetimeFormik
                                                        name={'activityBeginDate'}
                                                        dateFormat={this.props.dateFormat}
                                                        formik={this.props.formik}
                                                        placeHolder={T.t('r_datetime_picker_date')}
                                                        datePickerId={'activityByBeginDate'}
                                                        mode="single"
                                                        static={true}
                                                        activityType={this.props.activityType}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4">
                                                    <DatetimeFormik
                                                        name={'activityBeginTime'}
                                                        formik={this.props.formik}
                                                        datePickerId={'activityByBeginTime'}
                                                        placeHolder={T.t('r_time')}
                                                        mode="time"
                                                        time24Hr={true}
                                                        static={true}
                                                        activityType={this.props.activityType}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h5 className="mt-4 mt-0">{T.t('r_dont_show_after_date')}</h5>
                                    <div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                                        <div className="row" id="assignment_by_end_date" style={{ marginTop: 0 }}>
                                            <div className="col-md-6">
                                                <div className="form-input form-group date-picker mb-md-0">
                                                    <DatetimeFormik
                                                        name={'activityEndDate'}
                                                        dateFormat={this.props.dateFormat}
                                                        formik={this.props.formik}
                                                        placeHolder={T.t('r_datetime_picker_date')}
                                                        datePickerId={'activityByEndDate'}
                                                        mode="single"
                                                static={true}
                                                activityType={this.props.activityType}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4">
                                                    <DatetimeFormik
                                                        name={'activityEndTime'}
                                                        formik={this.props.formik}
                                                        datePickerId={'activityByEndTime'}
                                                        placeHolder={T.t('r_time')}
                                                        mode="time"
                                                        time24Hr={true}
                                                        static={true}
                                                        activityType={this.props.activityType}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={'animated ' + (this.props.formik.values.dateCriteria === 0 ? 'fadeInDown' : 'fadeOutDown')}
                                    style={{
                                        animationDuration: '0.3s',
                                        display: this.props.formik.values.dateCriteria === 0 ? 'block' : 'none',
                                        marginTop: '1.5rem'
                                    }}
                                >
                                    {this.props.isWeekly ? (
                                        <SelectAsync
                                            isMulti={true}
                                            isSearchable={true}
                                            requestType={'post'}
                                            isDisabled={!this.props.isWeekly}
                                            parameter={{
                                                courseId: this.props.coursePageActivityId,
                                                classId: this.props.coursePageClassId,
                                                isTiming: true,
                                                SelectedIds: this.props.formik.values.termWeekIds,
                                                activityConditionalBeginDate: this.props.formik.values.activityConditionalBeginDate
                                            }}
                                            placeHolder={T.t('r_select_by').replace('{0}', this.props.termType)}
                                            url={'api/term/courseweeks'}
                                            closeMenuOnScroll={false}
                                            closeMenuOnSelect={false}
                                            column={{ label: 'weekLabel', value: 'termWeekId' }}
                                            setSelectValue={this.props.isUpdate ? this.props.formik.values.termWeekIds : ''}
                                            name={'termWeekIds'}
                                            value={this.props.formik.values.termWeekIds}
                                            onChange={this.props.formik.handleChange}
                                            setFieldValue={this.props.formik.setFieldValue}
                                            errors={this.props.formik.errors.termWeekIds}
                                            touched={this.props.formik.touched.termWeekIds}
                                            isTouched={this.props.formik.setFieldTouched}
                                            setFieldOnlyValue={true}
                                            colourStyles={{
                                                menu: () => ({ zIndex: 999999 })
                                            }}
                                        />
                                    ) : (
                                        <h6 className="not-weekly-text">{T.t('r_not_weekly_course')}</h6>
                                    )}
                                </div>
                                <div
                                    className={'animated ' + (this.props.formik.values.dateCriteria === 2 ? 'fadeInDown' : 'fadeOutDown')}
                                    style={{
                                        animationDuration: '0.3s',
                                        display: this.props.formik.values.dateCriteria === 2 ? 'block' : 'none',
                                        marginTop: '1.5rem'
                                    }}
                                >
                                    <SelectAsync
                                        isMulti={false}
                                        isSearchable={true}
                                        isClearable={true}
                                        requestType={'post'}
                                        parameter={{
                                            CourseId: this.props.coursePageActivityId,
                                            classId: this.props.coursePageClassId,
                                            Take: 7,
                                            Skip: 0
                                        }}
                                        placeHolder={T.t('r_select_activity')}
                                        url={'api/get/conditionalactivities'}
                                        closeMenuOnScroll={false}
                                        closeMenuOnSelect={true}
                                        column={{ label: 'activityName', value: 'activityId' }}
                                        name={'datePrerequisiteActivityId'}
                                        value={this.props.formik.values.datePrerequisiteActivityId}
                                        onChange={this.handleDatePrerequisiteActivityId}
                                        setFieldValue={this.props.formik.setFieldValue}
                                        errors={this.props.formik.errors.datePrerequisiteActivityId}
                                        touched={this.props.formik.touched.datePrerequisiteActivityId}
                                        isTouched={this.props.formik.setFieldTouched}
                                        colourStyles={{
                                            menu: () => ({ zIndex: 999999 })
                                        }}
                                    />
                                </div>
                            </div>
                            <div
                                className={'animated ' + (this.props.formik.values.dateCriteria === 2 ? 'fadeInDown' : 'fadeOutDown')}
                                style={{
                                    animationDuration: '0.3s',
                                    display: 'none',
                                    padding: '1.8%'
                                }}
                            >
                                <Input
                                    type={'number'}
                                    name={'datePrerequisiteActivityHours'}
                                    label={T.t('r_time')}
                                    formik={this.props.formik}
                                    value={'0'}
                                />
                            </div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <h5 className="mt-4 mt-0">{T.t('r_activity_finish_criteria')}</h5>
                            <Tooltip data={T.t('r_activity_finish_criteria_info')} position='top'>
                                <img src={_common.GetDefaultIcons('info')} style={{ width: '1.25em', marginInlineStart: "20px"  }} alt="" />
                            </Tooltip>
                        </div>
                        {this.props && this.props.isUpdate != "" ?
                            <div className="row">
                                {this.props.formik.values.completionType === ActivityCompletionType.View ?
                                    <div className="col-md-4">
                                        <div className="radio-tabs tick-radio position-relative">
                                            <input
                                                type="radio"
                                                name={'completionType'}
                                                value={ActivityCompletionType.View}
                                                defaultChecked={true}
                                                onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.View)}
                                                id="completion-type-view"
                                                className="form-radio"
                                                checked={this.props.formik.values.completionType === ActivityCompletionType.View ? true : false}
                                            />
                                            <label htmlFor="completion-type-view">{T.t('r_display')}</label>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                            :
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="radio-tabs tick-radio position-relative">
                                        <input
                                            type="radio"
                                            name={'completionType'}
                                            value={ActivityCompletionType.View}
                                            defaultChecked={true}
                                            onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.View)}
                                            id="completion-type-view"
                                            className="form-radio"
                                            checked={this.props.formik.values.completionType === ActivityCompletionType.View ? true : false}
                                        />
                                        <label htmlFor="completion-type-view">{T.t('r_display')}</label>
                                    </div>
                                </div>
                            </div>
                        }
                        <h5 className="mt-4 mt-0">{T.t('r_activity_deadline_criteria')}</h5>
                        <div className="d-md-flex align-items-md-end delivery-date" style={{ marginTop: 0 }}>
                            <div className="row" id="forum_end_date" style={{ marginTop: 0 }}>
                                <div className="col-md-6">
                                    <div className="form-input form-group date-picker mb-md-0">
                                        <DatetimeFormik
                                            name={'taskDeadline'}
                                            dateFormat={this.props.dateFormat}
                                            formik={this.props.formik}
                                            placeHolder={T.t('r_datetime_picker_date')}
                                            datePickerId={'addActivityDate'}
                                            mode="single"
                                            dataClearable={true}
                                            static={true}
                                            activityType={this.props.activityType}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4">
                                        <DatetimeFormik
                                            name={'taskDeadlinetime'}
                                            formik={this.props.formik}
                                            datePickerId={'addActivityTime'}
                                            placeHolder={T.t('r_time')}
                                            mode="time"
                                            time24Hr={true}
                                            dataClearable={true}
                                            static={true}
                                            activityType={this.props.activityType}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

        );
    }
}

export default connect<ILTIActivityAddProps, IOuterProps>(LTIActivityContent);
